import { combineClasses } from "@/lib/utils";
import styles from "./TypeSelector.module.scss";

export interface TypeOption {
  value: string;
  label: string;
  caption: string;
}

export interface TypeSelectorProps {
  options: TypeOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TypeSelector = ({ options, value, onChange, disabled = false }: TypeSelectorProps) => (
  <div className={styles.grid}>
    {options.map((option) => (
      <button
        key={option.value}
        type="button"
        disabled={disabled}
        className={combineClasses(styles.option, value === option.value && styles.optionActive)}
        onClick={() => onChange(option.value)}
      >
        <span className={styles.optionLabel}>{option.label}</span>
        <span className={styles.optionCaption}>{option.caption}</span>
      </button>
    ))}
  </div>
);

export default TypeSelector;
